import { makeCommsPage } from './commsPage'
import { CommsDocumentIngestView } from '../components/views/commsDocumentIngestView'

export default makeCommsPage({
    title: 'Daily post',
    intro: 'Upload LOCs received in the post, as PDFs or scans (JPEG, PNG, TIFF), or a ZIP of them. Each letter is read, summarised, given its category and case action, and matched to a suggested case. Nothing is filed until you confirm the case. Outgoing letters are sent from LOC Batches.',
    probeUrl: 'comms/document-ingest/status',
    View: CommsDocumentIngestView,
    className: 'commsDocumentIngest',
})
